export default __webpack_public_path__ + "static/media/Group 3109.ea055427.png";